import { Link } from "wouter";
import { ArrowRight } from "lucide-react";

export function MtcIntroduction() {
  return (
    <section
      aria-labelledby="mtc-introduction-heading"
      className="border-b border-border/70 bg-muted/35 px-4 py-12 sm:px-6 sm:py-14 lg:px-8"
    >
      <div className="mx-auto max-w-[1080px]">
        <div className="grid grid-cols-1 gap-6">
          <div>
            <p className="mb-3 text-xs font-bold uppercase tracking-[0.18em] text-primary">
              Advancing Trauma Care Across Michigan
            </p>
            <h2
              id="mtc-introduction-heading"
              className="font-serif text-2xl font-bold leading-tight sm:text-3xl"
            >
              What is the Michigan Trauma Coalition?
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-muted-foreground sm:text-base">
              MTC is a voluntary, nonprofit membership organization of nearly 450
              representatives from more than 100 Michigan hospitals. Founded in
              1991 by hospitals and partner organizations, it brought trauma
              professionals together to advance a statewide trauma system at a
              time when Michigan lagged behind most other states.
            </p>
            <Link
              href="/about/mission"
              className="group mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary transition-colors hover:text-primary/75"
            >
              Learn more about MTC
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
            </Link>
          </div>

          <div className="grid gap-3 sm:grid-cols-2">
            <article className="rounded-lg border border-border/70 bg-background/75 p-4 transition-colors hover:border-primary/30">
              <h3 className="text-sm font-semibold">Our mission</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-muted-foreground sm:text-sm">
                Reduce the burden of traumatic injury through collaborative
                education, advocacy, and system improvement.
              </p>
            </article>
            <article className="rounded-lg border border-border/70 bg-background/75 p-4 transition-colors hover:border-primary/30">
              <h3 className="text-sm font-semibold">Our vision</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-muted-foreground sm:text-sm">
                Every person injured by trauma in Michigan receives optimal
                care and the best possible outcomes.
              </p>
            </article>
          </div>
        </div>

      </div>
    </section>
  );
}
